import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import Embers from "./Embers";
import { useSiteContent } from "@/context/SiteContentContext";
import { resolveAssetUrl } from "@/lib/api";

export default function Grill() {
  const { content } = useSiteContent();
  const grill = content?.grill || {};
  const cards = grill.cards || [];

  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-15%", "15%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.15, 1]);
  const textY = useTransform(scrollYProgress, [0, 1], ["10%", "-10%"]);

  return (
    <section id="grill" ref={ref} data-testid="grill-section" className="relative min-h-[110vh] bg-bg-alt overflow-hidden">
      <motion.div style={{ y, scale }} className="absolute inset-0">
        <img src={resolveAssetUrl(grill.image)} alt="Grill fire" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-[rgba(26,14,8,0.85)] via-[rgba(26,14,8,0.5)] to-[rgba(26,14,8,0.95)]" />
      </motion.div>

      <Embers count={20} />

      <motion.div
        style={{ y: textY }}
        className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10 pt-40 pb-32 md:pt-52 md:pb-44"
      >
        <p className="text-xs tracking-[0.4em] uppercase text-[color:var(--gold-hi)]">{grill.eyebrow}</p>
        <h2 className="mt-6 font-serif-display text-6xl md:text-8xl leading-[0.95] text-cream max-w-4xl">
          {grill.title_line_1} <br />
          <span className="italic gold-ink">{grill.title_line_2}</span>
        </h2>

        <div className="mt-16 grid md:grid-cols-3 gap-8 max-w-5xl">
          {cards.map((c, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.15, duration: 0.9 }}
              data-testid={`grill-card-${i}`}
              className="border-t border-warm pt-6"
            >
              <div className="text-[color:var(--gold-hi)] font-serif-display text-xl">{c.n}</div>
              <h3 className="mt-3 font-serif-display text-2xl text-cream">{c.h}</h3>
              <p className="mt-3 text-cream/80 leading-relaxed">{c.t}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
